import React, { useState } from 'react';
import { Link2, Copy, Check, ExternalLink } from 'lucide-react';
import { moduleApi } from '../../lib/api';

/**
 * Lien public d'une Démarche (2026-09-22, demande d'Emeni) : un lien le même pour tout le monde, à coller
 * sur Ma Carte, un site ou une bio. Le visiteur ouvre la Démarche sans l'avoir reçue par email ; ses
 * coordonnées lui sont demandées sur la page de réponse, qui crée la fiche CRM.
 * Couper le lien le rend inaccessible ; le réactiver redonne le même lien.
 */
const PUBLIC_ORIGIN = 'https://l-iamani.com';

export const DemarcheLienPublic: React.FC<{ template: { id: string; public_token?: string; public_enabled?: number | boolean; is_active?: boolean }; onChanged: () => void }> = ({ template, onChanged }) => {
    const [busy, setBusy] = useState(false);
    const [copied, setCopied] = useState(false);
    const [error, setError] = useState('');
    const enabled = !!Number(template.public_enabled) && !!template.public_token;
    const url = template.public_token ? `${PUBLIC_ORIGIN}/d/${template.public_token}` : '';

    const toggle = async () => {
        setBusy(true); setError('');
        try { await moduleApi.setDocumentTemplatePublicLink(template.id, !enabled); onChanged(); }
        catch (e: any) { setError(e?.message || 'Impossible de changer le lien.'); }
        finally { setBusy(false); }
    };
    const copy = async () => {
        try { await navigator.clipboard.writeText(url); setCopied(true); setTimeout(() => setCopied(false), 1800); } catch { /* refusé */ }
    };

    return (
        <div className="mt-2 flex items-center gap-2 flex-wrap">
            <button type="button" role="switch" aria-checked={enabled} onClick={toggle} disabled={busy}
                className="inline-flex items-center gap-2 text-xs font-semibold text-content-muted hover:text-content disabled:opacity-50">
                <span className={`relative w-8 h-[18px] rounded-full transition-colors ${enabled ? 'bg-emerald-500' : 'bg-border'}`}>
                    <span className={`absolute top-[2px] left-[2px] w-[14px] h-[14px] rounded-full bg-white shadow transition-transform ${enabled ? 'translate-x-[14px]' : ''}`} />
                </span>
                <Link2 size={13} /> Lien public
            </button>
            {enabled && (<>
                <button type="button" onClick={copy}
                    className="inline-flex items-center gap-1.5 text-xs font-semibold px-2.5 py-1 rounded-lg border border-border bg-surface hover:bg-surface-soft text-content">
                    {copied ? <Check size={13} /> : <Copy size={13} />} {copied ? 'Lien copié' : 'Copier le lien'}
                </button>
                <a href={url} target="_blank" rel="noopener noreferrer" title="Ouvrir le lien"
                    className="inline-flex items-center p-1 rounded-md text-content-muted hover:text-content"><ExternalLink size={13} /></a>
                {!template.is_active && <span className="text-[11px] text-amber-600 dark:text-amber-400">Démarche désactivée : le lien ne s'ouvre pas.</span>}
            </>)}
            {error && <span className="text-[11px] text-red-600">{error}</span>}
        </div>
    );
};
